import React from 'react';
import { render } from 'react-dom';
import EventsList from './apps/EventsList/EventsList';

// Events List Application
const eventsList = document.getElementById('events-app');
if (eventsList) render(<EventsList {...eventsList.dataset} />, eventsList);
